<template>
  <LoginForm />
</template>

<script>
import LoginForm from '@Components/LoginForm.vue';

export default {
  components: {
    LoginForm,
  },
};
</script>
